import React, { Component } from 'react';
import RevSlider, { Slide, Caption } from 'react-rev-slider';
import BlogLast from './BlogLast';
import { Link } from 'react-router';


export default class Home extends Component {

    componentDidMount() {

    }

    render() {

        const config = {
            sliderType: "standard",
            sliderLayout: "fullwidth",
            delay: 15000,
            className: "rev_slider matrox-slider",
            navigation: {
                keyboardNavigation: "on",
                keyboard_direction: "horizontal",
                mouseScrollNavigation: "off",
                onHoverStop: "off",
                touch: {
                    touchenabled: "on",
                    swipe_threshold: 75,
                    swipe_min_touches: 1,
                    swipe_direction: "horizontal",
                    drag_block_vertical: false
                },
                arrows: {
                    style: "gyges",
                    enable: true,
                    hide_onmobile: false,
                    hide_onleave: true,
                    tmp: '',
                    left: {
                        h_align: "left",
                        v_align: "center",
                        h_offset: 10,
                        v_offset: 0
                    },
                    right: {
                        h_align: "right",
                        v_align: "center",
                        h_offset: 10,
                        v_offset: 0
                    }
                }
            }

        };

        return (
            <div>
                <section className="rev_slider_wrapper" >
                    <RevSlider config={config}>
                        <Slide
                            data-classname="rev_slider matrox-slider"
                            src="./assets/img/banner/banner-lapis.jpg"
                            alt="slidebg1"
                            data-bgfit="cover"
                            data-bgposition="left top"
                            data-bgrepeat="no-repeat"
                            slideProperties={{
                                'data-transition': "fade",
                                'data-slotamount': "default",
                                'data-easein': "Power4.easeInOut",
                                'data-easeout': "Power4.easeInOut",
                                'data-masterspeed': "2000",
                                'data-thumb': "assets/img/banner/full_5.jpg",
                                'data-rotate': "0",
                                'data-fstransition': "fade",
                                'data-fsmasterspeed': "1500",
                                'data-fsslotamount': "7",
                                'data-saveperformance': "off",
                                'data-description': ""
                            }}>

                            <Caption
                                class="tp-caption font-20 rev-heading text-bold tp-resizeme"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['-100','-100','-50','-50']"
                                data-fontsize="['60','60','50','55']"
                                data-lineheight="['70','70','60','60']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1000"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', fontSize: '10px!important', color: '#495057' }}>
                                SIGA - Sistema de Gestão Acadêmica
                            </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-subheading"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['20','20','10','10']"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"

                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                //data-mask_in="x:0px;y:[100%];s:inherit;e:inherit;" 
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1200"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', overflow: 'none', color: '#495057', fontWeight: 'bold' }}>
                                SIGA é um ERP Educacional (Enterprise Resource Planning), resultante de 15 anos de experiência <br />
                                em desenvolvimento de sistemas para escolas, faculdades e universidades.<br />
                                Integre os setores Acadêmico, Pedagógico e Financeiro<br /> de sua Instituição.
                            </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-btn  rs-parallaxlevel-0"
                                data-x="['left','left','left','left']"
                                data-hoffset="['0','0','0','0']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['120','120','100','100']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-style_hover="cursor:default;"

                                data-transform_in="y:50px;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                data-mask_out="x:inherit;y:inherit;"
                                data-start="1400"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '8', whiteSpace: 'nowrap' }}>
                                <Link className="btn btn-lg  waves-effect waves-light" to="/solutions/educational">Quero saber mais</Link>
                            </Caption>
                        </Slide>



                        <Slide
                            data-classname="rev_slider matrox-slider"
                            src="http://wwwcdn.howdesign.com/wp-content/uploads/shutterstock_363472727.jpg"
                            alt="slidebg1"
                            data-bgfit="cover"
                            data-bgposition="left top"
                            data-bgrepeat="no-repeat"
                            slideProperties={{
                                'data-transition': "fade",
                                'data-slotamount': "default",
                                'data-easein': "Power4.easeInOut",
                                'data-easeout': "Power4.easeInOut",
                                'data-masterspeed': "2000",
                                'data-thumb': "assets/img/banner/full_5.jpg",
                                'data-rotate': "0",
                                'data-fstransition': "fade",
                                'data-fsmasterspeed': "1500",
                                'data-fsslotamount': "7",
                                'data-saveperformance': "off",
                                'data-description': ""
                            }}>

                            <Caption
                                class="tp-caption rev-heading text-extrabold white-text tp-resizeme"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['-100','-100','-50','-50']"
                                data-fontsize="['60','60','50','55']"
                                data-lineheight="['70','70','60','60']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                //data-mask_in="x:0px;y:[100%];s:inherit;e:inherit;"
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1000"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', fontSize: '50px!important' }}>
                                FC Varejo e Atacado
		                    </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-subheading white-text"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['20','20','10','10']"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"

                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                //data-mask_in="x:0px;y:[100%];s:inherit;e:inherit;" 
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1200"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', overflow: 'none', fontWeight: 'bold' }}>
                                Um sistema de gestão completo, 100% na nuvem e flexível para se adaptar ao seu negócio.<br />
                                Com o FC Varejo você ganha tempo para focar no seu negócio.<br />
                                Além de facilidades como NFe, SAT entre outros.
		                    </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-btn  rs-parallaxlevel-0"
                                data-x="['left','left','left','left']" data-hoffset="['0','0','0','0']"
                                data-y="['middle','middle','middle','middle']" data-voffset="['100','100','100','100']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-style_hover="cursor:default;"

                                data-transform_in="y:50px;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                data-mask_out="x:inherit;y:inherit;"
                                data-start="1400"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '8', whiteSpace: 'nowrap' }}>
                                <Link className="btn btn-lg  waves-effect waves-light orange" to="/solutions/educational">Quero saber mais</Link>
                            </Caption>
                        </Slide>


                        <Slide
                            data-classname="rev_slider matrox-slider"
                            // src="https://www.softwareobjectives.com.au/img/banner1.jpg"
                            src="./assets/img/banner/background1.jpg"
                            alt="slidebg1"
                            data-bgfit="cover"
                            data-bgposition="left top"
                            data-bgrepeat="no-repeat"
                            slideProperties={{
                                'data-transition': "fade",
                                'data-slotamount': "default",
                                'data-easein': "Power4.easeInOut",
                                'data-easeout': "Power4.easeInOut",
                                'data-masterspeed': "2000",
                                'data-thumb': "assets/img/banner/full_5.jpg",
                                'data-rotate': "0",
                                'data-fstransition': "fade",
                                'data-fsmasterspeed': "1500",
                                'data-fsslotamount': "7",
                                'data-saveperformance': "off",
                                'data-description': ""
                            }}>

                            <Caption
                                class="tp-caption rev-heading text-extrabold tp-resizeme white-text"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['-100','-100','-50','-50']"
                                data-fontsize="['60','60','50','55']"
                                data-lineheight="['70','70','60','60']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                //data-mask_in="x:0px;y:[100%];s:inherit;e:inherit;"
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1000"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', fontSize: '50px!important', color: '#495057' }}>
                                FC-Labs - Software Lab
		                    </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-subheading white-text"
                                data-x="['left','left','left','left']"
                                data-hoffset="['30','30','30','30']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['15','15','10','10']"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"

                                data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                //data-mask_in="x:0px;y:[100%];s:inherit;e:inherit;" 
                                data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                                data-start="1200"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '5', whiteSpace: 'nowrap', overflow: 'none', fontWeight: 'bold' }}>
                                Atuamos como laboratório de software provendo soluções customizadas para sua empresa,<br />
                                agregamos valor ao seu negócio através de projetos desenvolvidos sob-medida para você,<br />
                                desta forma estudamos a sua ideia e alavancamos o sua empresa através de ações co-criativas
                                <br />realizadas com você e sua equipe.
		                    </Caption>

                            <Caption
                                class="tp-caption tp-resizeme rev-btn  rs-parallaxlevel-0"
                                data-x="['left','left','left','left']"
                                data-hoffset="['0','0','0','0']"
                                data-y="['middle','middle','middle','middle']"
                                data-voffset="['120','120','100','100']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-transform_idle="o:1;"
                                data-style_hover="cursor:default;"

                                data-transform_in="y:50px;opacity:0;s:900;e:Power4.easeInOut;"
                                data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                                data-mask_out="x:inherit;y:inherit;"
                                data-start="1400"
                                data-splitin="none"
                                data-splitout="none"
                                data-responsive_offset="on"
                                style={{ zIndex: '8', whiteSpace: 'nowrap' }}>
                                <Link className="btn btn-lg  waves-effect black white-text" to="/solutions/custom">Quero saber mais</Link>
                            </Caption>
                        </Slide>
                    </RevSlider>
                </section >


                <section id="feature" className="section-padding gray-bg">
                    <div className="container">

                        <div className="row equal-height-row">
                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon"></i>
                                    </div>
                                    <div className="desc">
                                        <h2>Backup automático</h2>
                                        <p>O backup é feito de forma automatizada várias fezes ao dia, previnindo erros e perdas.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">cloud_download</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Importação de dados</h2>
                                        <p>Importamos seus dados do seu sistema atual para a nossa base de dados.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon"></i>
                                    </div>
                                    <div className="desc">
                                        <h2>Segurança</h2>
                                        <p>Hospesagem das suas informações com escalabilidade, segurança e responsabilidade.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">insert_emoticon</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Implantação</h2>
                                        <p>Implantação e treinamento com Profissionais Qualificados e Especializados na sua área de atuação.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">cloud_queue</i>
                                    </div>
                                    <div className="desc">
                                        <h2>100% Online</h2>
                                        <p>Sistemas 100% Online provendo seu acesso por qualquer dispositivo com acesso a internet.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">contact_phone</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Suporte</h2>
                                        <p>Suporte técnico online em horário comercial e presencial com agendamento.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <div className="promo-box dark-bg">
                    <div className="container">
                        <div className="col-md-12 light-grey-text">
                            <div className="promo-info">
                                <span className="white-text text-uppercase">Que saber mais sobre nossos serviços?</span>
                                <h2 className="font-30 white-text text-bold text-uppercase no-margin">Entre em contato sem compromisso!</h2>
                            </div>
                            <div className="promo-btn white-text">
                                <Link className="btn waves-effect waves-grey orange" to="contact">Fale conosco</Link>
                            </div>
                        </div>
                    </div>
                </div>


                <section className="section-padding padding-bottom-0">
                    <div className="container">
                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Nossos parceiros</h2>
                        </div>

                        <div className="clients-grid grid-gutter">
                            <div className="row">
                                <div className="col-md-3 col-sm-6">
                                    <div className="border-box">
                                        <a>
                                            <img style={{ 'WebkitFilter': 'grayscale(0%)', filter: 'grayscale(0%)' }} src="./assets/img/parceiros/digitalocean.png" alt="clients" />
                                        </a>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-6">
                                    <div className="border-box">
                                        <a>
                                            <img style={{ 'WebkitFilter': 'grayscale(0%)', filter: 'grayscale(0%)' }} src="./assets/img/parceiros/aws.png" alt="clients" />
                                        </a>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-6">
                                    <div className="border-box">
                                        <a>
                                            <img style={{ 'WebkitFilter': 'grayscale(0%)', filter: 'grayscale(0%)' }} src="./assets/img/parceiros/google.png" alt="clients" />
                                        </a>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-6">
                                    <div className="border-box">
                                        <a>
                                            <img style={{ 'WebkitFilter': 'grayscale(0%)', filter: 'grayscale(0%)' }} src="./assets/img/parceiros/microsoft-azure.png" alt="clients" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </section>

                <section className="padding-top-110 padding-bottom-70 brand-bg">
                    <div className="container">
                        <div className="col-md-8 col-md-offset-2">
                            <div className="content text-center">
                                <div className="testimonial-meta font-20 text-extrabold white-text">
                                    SERVIÇOS
                                </div>
                                <h2 className="white-text line-height-40">
                                    A nossa equipe está pronta para atender a sua empresa! Além de produtos completos, oferecemos serviços que complementam e facilitam a experiência do usuário.
                                </h2>
                            </div>
                        </div>
                    </div>
                </section>

                <BlogLast />                
                
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js